import React, { useEffect, useState } from "react";
import LOCAL_KEYS, {
  parseLocalStorageJSON,
} from "../../../helpers/Localstorage";
import {
  Groups2Outlined,
  Business,
  AssignmentOutlined,
  AccessTime,
  RequestQuoteOutlined,
} from "@mui/icons-material";
import ThumbDownOffAltIcon from '@mui/icons-material/ThumbDownOffAlt';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import ReceiptIcon from "@mui/icons-material/Receipt";
import { FiChevronsLeft, FiChevronsRight } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../../components/Loader";
import {
  requestDashboardList,
  requestDashboardMonthlyHours,
  setResetDashboardMonthlyHours,
  setResetStateDashboardList,
} from "../../../Redux/DashboardState/dashBoardActionCreator";
import { Link, useNavigate } from "react-router-dom";
import { Pie, Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
} from 'chart.js';

ChartJS.register(
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title
);

const AdminDashboard = () => {
  const userDetails = parseLocalStorageJSON(LOCAL_KEYS.USER_DETAILS);
  const countList = useSelector((state) => state.DashboardListReducer);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showDetails, setShowDetails] = useState({});
  const dashboardMonthlyHours = useSelector((state) => state.DashboardMonthlyHoursReducer);

  // Function to get last 6 months data
  const getLastSixMonths = () => {
    if (dashboardMonthlyHours?.response) {
      return dashboardMonthlyHours.response.map(item => {
        const [month, year] = item.month.split(' ');
        return `${month} ${year}`;
      });
    }
    return [];
  };

  // Function to get working hours data from reducer
  const getWorkingHoursData = () => {
    if (dashboardMonthlyHours?.response) {
      const activeEmployees = countList?.response?.EmployeesList?.Employees;
      return dashboardMonthlyHours.response.map(item => item.totalHours * activeEmployees);
    }
    return [];
  };

  const cards = [
    {
      title: "Timesheets",
      count: countList?.response?.TimesheetsList?.["Timesheets For approval"],
      caption: "To be Approved",
      captionColor: "text-purple-600",
      icon: (
        <AccessTime fontSize={"large"} className="w-12 h-12 text-purple-600" />
      ),
      link: "/pendingTimesheets", 
    },
    {
      title: "Rejected Timesheets",
      count: countList?.response?.TimesheetsList?.["Rejected"],
      // caption: "Rejected",
      // captionColor: "text-orange-600",
      icon: (
        <ThumbDownOffAltIcon fontSize={"large"} className="w-12 h-12 text-orange-600" />
      ),
      link: "/rejectedTimesheets",
    },
    {
      title: "Approved Timesheets",
      count: countList?.response?.TimesheetsList?.["Not Invoiced"],
      caption:"Not Invoiced",
      captionColor: "text-blue-600",
      icon: (
        <RequestQuoteIcon fontSize={"large"} className="w-12 h-12 text-blue-600" />
      ),
      link: "/tobeinvoiced",
    },
    {
      title: "Invoices",
      count: countList?.response?.InvoicesList?.PendingPayments,
      caption: "Pending Payment",
      captionColor: "text-yellow-600",
      icon: (
        <RequestQuoteOutlined fontSize={"large"} className="w-12 h-12 text-yellow-600" />
      ),
      link: "/pendingInvoices",
    },
    {
      title: "Employees",
      count: countList?.response?.EmployeesList?.Employees,
      caption: "Active",
      captionColor: "text-green-600",
      // activeEmployees: countList?.response?.EmployeesList?.ActiveEmployees,
      // inactiveEmployees: countList?.response?.EmployeesList?.InactiveEmployees,
      icon: (
        <Groups2Outlined
          fontSize={"large"}
          className="w-20 h-20  text-primary"
        />
      ),
      isUsersCard: true,
      link: "/manageemployee",
    },

    {
      title: "Projects",
      count: countList?.response?.ProjectsList,
      icon: (
        <AssignmentOutlined
          fontSize={"large"}
          className="w-12 h-12 text-green-600"
        />
      ),
      link: "/addproject",
    },

    {
      title: "Clients",
      count: countList?.response?.ClientsList,
      icon: (
        <Business fontSize={"large"} className="w-12 h-12 text-orange-600" />
      ),
      link: "/addclient",
    },
    

  ];

  const toggleDetails = (cardTitle) => {
    setShowDetails((prev) => ({
      ...prev,
      [cardTitle]: !prev[cardTitle],
    }));
  };
  useEffect(() => {
    dispatch(setResetStateDashboardList());
    dispatch(requestDashboardList());
    dispatch(setResetDashboardMonthlyHours());
    dispatch(requestDashboardMonthlyHours());
  }, []);

  useEffect(() => {
    if (countList?.error && !countList?.loading) {
      dispatch(setResetStateDashboardList());
    }
  }, [countList]);

  useEffect(() => {
    if(dashboardMonthlyHours?.error && !dashboardMonthlyHours.loading) {
      dispatch(setResetDashboardMonthlyHours());
    }
  },[dashboardMonthlyHours])
 
  return (
    <div className="p-5 container-fluid h-[85vh] overflow-y-scroll">
      <Loader isLoading={countList?.loading} />
      <h2 className="text-primary text-xl font-semibold mb-4">
        Hi {`${userDetails?.firstName || ""} ${userDetails?.lastName || ""}`},
        welcome to Admin Dashboard
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        {cards.map((card, index) => (
          <div key={index} className="bg-white p-4 rounded-xl shadow-md h-[140px]">
            <div className="flex items-center gap-2">
                {card?.icon}
                <div>
                  <h3 className="text-lg font-semibold text-gray-800">
                    {card?.title}
                  </h3>
                  {card.caption && (
                    <span className={`text-xs ${card.captionColor} font-medium block`}>{card.caption}</span>
                  )}
                </div>
            </div>

            <div className="flex items-center justify-between mt-2">
              <p className="text-3xl font-bold text-gray-900">{card.count}</p>
            </div>

            <div className="mt-2">
              <Link
                to={card.link}
                className="text-sm text-primary hover:text-secondaryBlue"
              >
                View All
              </Link>
            </div>
          </div>
        ))}
      </div>

      {/* Charts Section */}
      <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Timesheet Status Pie Chart */}
        <div className="bg-white p-4 rounded-xl shadow-md">
          <h3 className="text-lg font-semibold text-gray-800 mb-2">Timesheet Status Distribution</h3>
          <div className="h-[200px] flex justify-center items-center relative">
            <Pie
              data={{
                labels: ['Pending Approval', 'Rejected', 'Not Invoiced'],
                datasets: [
                  {
                    data: [
                      countList?.response?.TimesheetsList?.["Timesheets For approval"] || 0,
                      countList?.response?.TimesheetsList?.["Rejected"] || 0,
                      countList?.response?.TimesheetsList?.["Not Invoiced"] || 0
                    ],
                    backgroundColor: [
                      'rgba(99, 102, 241, 0.8)',  // Indigo
                      'rgba(239, 68, 68, 0.8)',   // Red
                      'rgba(16, 185, 129, 0.8)',  // Green
                    ],
                    borderColor: 'white',
                    borderWidth: 2,
                    hoverOffset: 15,
                    borderRadius: 5,
                  },
                ],
              }}
              options={{
                responsive: true,
                maintainAspectRatio: false,
                cutout: '60%',
                onClick: (event, elements) => {
                  if (elements && elements.length > 0) {
                    const index = elements[0].index;
                    const routes = ['/pendingTimesheets', '/rejectedTimesheets', '/tobeinvoiced'];
                    navigate(routes[index]);
                  }
                },
                onHover: (event, elements) => {
                  event.native.target.style.cursor = elements.length ? 'pointer' : 'default';
                },
                plugins: {
                  legend: {
                    position: 'bottom',
                    labels: {
                      padding: 20,
                      font: {
                        size: 12,
                        family: "'Inter', sans-serif"
                      },
                      usePointStyle: true,
                      pointStyle: 'circle'
                    }
                  },
                  tooltip: {
                    backgroundColor: 'rgba(0, 0, 0, 0.8)',
                    padding: 12,
                    titleFont: {
                      size: 14,
                      family: "'Inter', sans-serif"
                    },
                    bodyFont: {
                      size: 13,
                      family: "'Inter', sans-serif"
                    },
                    callbacks: {
                      label: function(context) {
                        const label = context.label || '';
                        const value = context.raw || 0;
                        const total = context.dataset.data.reduce((a, b) => a + b, 0);
                        const percentage = Math.round((value / total) * 100);
                        return `${label}: ${value} (${percentage}%)`;
                      }
                    }
                  }
                },
                animation: {
                  animateScale: true,
                  animateRotate: true
                }
              }}
            />
            <div className="absolute top-[40%] left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-center">
              <p className="text-2xl font-bold text-gray-800">
                {countList?.response?.TimesheetsList?.["Timesheets For approval"] + 
                 countList?.response?.TimesheetsList?.["Rejected"] + 
                 countList?.response?.TimesheetsList?.["Not Invoiced"] || 0}
              </p>
            </div>
          </div>
        </div>

        {/* Monthly Working Hours Line Chart */}
        <div className="bg-white p-4 rounded-xl shadow-md">
          <h3 className="text-lg font-semibold text-gray-800 mb-2">Monthly Working Hours Overview</h3>
          <div className="h-[200px]">
            <Line
              data={{
                labels: getLastSixMonths(),
                datasets: [
                  {
                    label: 'Total Working Hours',
                    data: getWorkingHoursData(),
                    borderColor: 'rgb(99, 102, 241)',
                    backgroundColor: 'rgba(99, 102, 241, 0.1)',
                    borderWidth: 3,
                    tension: 0.4,
                    fill: true,
                    pointBackgroundColor: 'rgb(99, 102, 241)',
                    pointBorderColor: '#fff',
                    pointBorderWidth: 2,
                    pointRadius: 5,
                    pointHoverRadius: 7,
                    pointStyle: 'circle',
                    showLine: true,
                    spanGaps: false,
                    stepped: false,
                  },
                ],
              }}
              options={{
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                  legend: {
                    display: false,
                  },
                  tooltip: {
                    backgroundColor: 'rgba(0, 0, 0, 0.8)',
                    padding: 12,
                    titleFont: {
                      size: 14,
                      family: "'Inter', sans-serif"
                    },
                    bodyFont: {
                      size: 13,
                      family: "'Inter', sans-serif"
                    },
                    callbacks: {
                      label: function(context) {
                        const totalHours = context.raw || 0;
                        const monthIndex = context.dataIndex;
                        const monthTotalHours = dashboardMonthlyHours?.response?.[monthIndex]?.totalHours ?? 0;
                        const activeEmployees = countList?.response?.EmployeesList?.Employees ?? 0;
                        const activeCount = typeof activeEmployees === 'number' ? activeEmployees : 0;
                        return [
                          `Approved Working Hours: ${monthTotalHours.toLocaleString()}`,
                          `Active Employees: ${activeCount}`,
                          `All Employees Working Hours: ${totalHours.toLocaleString()}`
                        ];
                      }
                    }
                  }
                },
                scales: {
                  y: {
                    beginAtZero: true,
                    grid: {
                      color: 'rgba(0, 0, 0, 0.1)',
                    },
                    ticks: {
                      callback: function(value) {
                        return (value / 1000).toFixed(1) + 'k';
                      },
                      stepSize: 1000
                    },
                    min: 0,
                    max: Math.ceil(Math.max(...getWorkingHoursData()) / 1000) * 1000
                  },
                  x: {
                    grid: {
                      display: false,
                    }
                  }
                },
                interaction: {
                  intersect: false,
                  mode: 'index'
                },
                elements: {
                  line: {
                    tension: 0.4,
                    borderWidth: 3,
                    borderColor: 'rgb(99, 102, 241)',
                  },
                  point: {
                    radius: 5,
                    hoverRadius: 7,
                    backgroundColor: 'rgb(99, 102, 241)',
                    borderColor: '#fff',
                    borderWidth: 2,
                  }
                }
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
